module.exports = {
      id: "slider-next-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#slider-next",
      toString: function () {
        return this.url;
      }
    }